import { InjectionToken } from '@angular/core';

/** Configuration for the v2 i18n subsystem. */
export interface I18nConfig {
  /**
   * Cache lifetime in milliseconds. Currently 3 minutes — within the window a
   * read returns the cached map; after it, translations are re-fetched fresh.
   * Raise for production (e.g. 12h = 1000 * 60 * 60 * 12) once the API is wired.
   */
  cacheTtlMs: number;

  /** Default to the offline mock repository (runs immediately, no backend). */
  useMock: boolean;

  /** Persist fetched translations to localStorage between sessions. */
  useLocalStorage: boolean;

  /** Use Angular TransferState to hand SSR-fetched translations to the client. */
  useTransferState: boolean;
}

export const DEFAULT_I18N_CONFIG: I18nConfig = {
  cacheTtlMs: 0 * 60 * 1000, // ← translation cache = 0 minutes
  // Use the REAL API (not the offline mock) for translations AND home content
  // (this same flag binds the Home repository — see features/home/home.providers.ts).
  // Each repo still degrades gracefully (local dictionary / mock merge) if the API fails.
  useMock: false,
  useLocalStorage: false,
  useTransferState: false,
};

export const I18N_CONFIG = new InjectionToken<I18nConfig>('I18N_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_I18N_CONFIG,
});
